import type { WorktimeStatistic } from '@/type';

import { minutesToHourMinuteSecond } from '../date';

export const makeAvgTime = (
  data: SelectiveRequired<
    WorktimeStatistic,
    | 'reviewFrameCount'
    | 'reworkFrameCount'
    | 'workFrameCount'
    | 'workTime'
    | 'reviewTime'
    | 'reworkTime'
  >,
) => {
  return {
    work: workTimeToString(data.workTime / data.workFrameCount),
    review: workTimeToString(data.reviewTime / data.reviewFrameCount),
    rework: workTimeToString(data.reworkTime / data.reworkFrameCount),
  };
};

export const workTimeToString = (workTime: number) => {
  const { hours, minutes, seconds } = minutesToHourMinuteSecond(workTime / 60);

  let result = `${minutes}m ${seconds}s`;

  if (hours) {
    result = `${hours}h ${result}`;
  }

  return result;
};
